import facebookBtn from './FacebookBtn'

export default facebookBtn
